(function () {
    'use strict';
    Controllers.ScheduleMeetingModalController = class ScheduleMeetingModalController extends Controllers.BaseControllerES6 {

        // @ngInject
        constructor($scope, $injector, $translate, $modalInstance, $state, _, options, moment, UsersManager, EventsManager, CompaniesManager,
                    PopupMessageService, AnalyticsService, EventService, FacebookPixelTrackingService, UiPersistenceService,
                    ModalService, OnboardingService, DeviceService, CalendarService, $q, AppStates) {
            super($scope, $injector);
            this.__objectType = 'ScheduleMeetingModalController';
            this.modalInstance = $modalInstance;
            this.translate = $translate;
            this._ = _;
            this.moment = moment;

            this.AppStates = AppStates;
            this.UsersManager = UsersManager;
            this.EventsManager = EventsManager;
            this.CompaniesManager = CompaniesManager;
            this.EventService = EventService;
            this.PopupMessageService = PopupMessageService;
            this.AnalyticsService = AnalyticsService;
            this.FacebookPixelTrackingService = FacebookPixelTrackingService;
            this.UiPersistenceService = UiPersistenceService;
            this.OnboardingService = OnboardingService;
            this.ModalService = ModalService;
            this.CalendarService = CalendarService;
            this.$q = $q;
            this.$state = $state;

            this.ANALYTICS_EVENT_SOURCE = `${this.AnalyticsService.analytics_events.schedule_meeting} modal`;
            this.SERVER_DATE_FORMAT = 'YYYY-MM-DD';
            this.TIME_FORMAT = 'h:mm a';

            // modal params
            this.options = options;

            this.isMobile = DeviceService.nxSmallBreakpoint();
            this.isEditMode = this.options ? !this.options.isCreateMeeting : false;

            this.googleCalendarProvider = null;

            // existing meeting
            if(this.isEditMode && this.options.calendarItemModel) {
                this.existingMeetingParams = this.options.calendarItemModel;
            }
            this.currUser = this.UsersManager.getCurrUser();
            this.meetingFormBinding = {};
            this.projectFormBinding = {};
            this.errors = {};
            this.project = this.EventsManager.newEvent();

            if ((this.options && this.options.type) || this.existingMeetingParams) {
              this.AnalyticsService.trackLoad(this, this.ANALYTICS_EVENT_SOURCE, {session_type: this.options.type || this.existingMeetingParams.type});
            }
            else {
              this.AnalyticsService.trackLoad(this, this.ANALYTICS_EVENT_SOURCE);
            }

            this.isCreateProject = false;
            this.initTitle();
            this.initButtonLabel();

            var promiseProvider = this.UsersManager.getCalendarProvider(this.currUser)
                .then(function (response) {
                    this.googleCalendarProvider = response.data.calendar_provider;
                }.bind(this));

            // init create project form
            this._initProTip();
            this._onboardingCreateEventToolTipStep(); //TODO: deprecate
        }

        showCreateProject() {
            this.isCreateProject = true;
            this.initTitle();
            this.initButtonLabel();
        }

        openSyncModal(hasPendingChanges) {
            if (hasPendingChanges) {

                // show confirm popup
                this.PopupMessageService.showConfirmPromise(
                    this.PopupMessageService.severityTypes.none,
                    'You have unsaved pending changes, would you like to continue and discard changes?',
                    'YES, DISCARD',
                    'FREQUENT_BUTTONS._CANCEL_',
                    'Are you sure?').then(function() {
                    this.AnalyticsService.trackConfirm(this, this.AnalyticsService.analytics_events.discard_meeting_changes);
                    this.modalInstance.dismiss();
                    this.$state.go(this.AppStates.root_core_navigation_calendar, {integrateFromScheduling: true});
                }.bind(this)).catch(function() {
                    this.AnalyticsService.trackCancel(this, this.AnalyticsService.analytics_events.discard_meeting_changes);
                }.bind(this));
            } else {
                this.modalInstance.dismiss();
                this.$state.go(this.AppStates.root_core_navigation_calendar, {integrateFromScheduling: true});
            }
        }

        initButtonLabel() {
            if(this.isCreateProject) {
                this.buttonLabel = 'PROJECT.BUTTONS._CREATE_PROJECT_';
            } else {
                this.buttonLabel = this.isEditMode ? 'CALENDAR.SCHEDULE_MEETING_MODAL._UPDATE_' : 'CALENDAR.SCHEDULE_MEETING_MODAL._CREATE_';
            }
        }

        initTitle() {
            if(this.isCreateProject) {
                this.title = 'PROJECT.CREATE_PROJECT_MODAL._TITLE_';
            } else {
                this.title = this.isEditMode ? 'CALENDAR.SCHEDULE_MEETING_MODAL._TITLE_UPDATE_' : 'CALENDAR.SCHEDULE_MEETING_MODAL._TITLE_';
            }
        }

        submitForm() {

            if(this.isCreateProject) {
                this.AnalyticsService.trackClick(this, this.AnalyticsService.analytics_events.create_project_modal,
                    {source: this.ANALYTICS_EVENT_SOURCE, session_type: this.meetingFormBinding.meetingType ? this.meetingFormBinding.meetingType.key : ''});
                this.createProject();
            }
            else if(this.isEditMode) {
                this.AnalyticsService.trackClick(this, this.AnalyticsService.analytics_events.update_meeting,
                    {source: this.ANALYTICS_EVENT_SOURCE, session_type: this.meetingFormBinding.meetingType ? this.meetingFormBinding.meetingType.key : ''});
                this.updateMeeting();
            }
            else {
                this.AnalyticsService.trackClick(this, this.AnalyticsService.analytics_events.schedule_meeting,
                    {source: this.ANALYTICS_EVENT_SOURCE, session_type: this.meetingFormBinding.meetingType ? this.meetingFormBinding.meetingType.key : ''});
                this.createMeeting();
            }

        }

        close() {
            if(this.isCreateProject) {
                this._closeCreateProjectModal();
            }
            else {
                this.AnalyticsService.trackClick(this, ['close', this.ANALYTICS_EVENT_SOURCE].join(' '), {source: this.ANALYTICS_EVENT_SOURCE, session_type: this.existingMeetingParams ? this.existingMeetingParams.type : this.options.type});
                this.modalInstance.dismiss();
            }
        }

        createProject() {
            if(!this.creatingProject) {
                this.projectFormBinding.projectForm.$setSubmitted();
                let projectForm = this.projectFormBinding.projectForm;
                if (projectForm.$dirty && projectForm.$valid && !projectForm.errorMessage && this._isValidProjectDate()) {
                    this.creatingProject  = true;
                    this.company = this.CompaniesManager.getCurrCompany();
                    this.project.event_image = this.EventService.getInitialProjectImage(this.company);
                    this.EventsManager.createEvent(this.project, this.addedContactId).then((resp) => {
                        this.AnalyticsService.trackSuccess(this, 'project created', this._getProjectAnalyticsProps(this.project));
                        this.FacebookPixelTrackingService.trackCustom('ProjectCreated');
                        if(resp.data) {
                            const workspaceId = resp.data._id;
                            const selectedWorkspace = {
                                _id: resp.data._id,
                                properties: {
                                    event_id: resp.data.event._id,
                                    event_name: resp.data.event.event_name
                                }
                            };
                            this.meetingFormBinding.setConnectedProject(selectedWorkspace);
                            this.isCreateProject = false;
                            this.initButtonLabel();
                            this.initTitle();
                            this._onboardingCreateEventStep(workspaceId); //TODO: deprecate
                        }

                        // Add the newly created event to the master collection and manually trigger a success
                        const eventsMasterCollection = this.EventsManager.getEventsMasterCollection();
                        eventsMasterCollection.add(this.project);

                        this.creatingProject = false;
                    }).catch((resp) => {
                        this.AnalyticsService.trackError(this, 'create project', this);
                        this.errorMessage = resp.data.error_message || resp.data;
                        this.creatingProject = false;

                    });
                }
            }
        }

        createMeeting() {
            if(!this.creatingCalendarItem) {
                this.meetingFormBinding.meetingForm.$setSubmitted();

                if(this._isValidMeeting()) {
                    this.creatingCalendarItem = true;
                    const meetingParams = this._prepareMeetingParams();

                    const defer = this.$q.defer();

                    if (this.CalendarService.hasInvitees(meetingParams) ||
                        this.CalendarService.isConnectedToProject(meetingParams)) {
                        this.showOverlay = true;
                        this.PopupMessageService.showConfirmPromise(
                            this.PopupMessageService.severityTypes.none,
                            'CALENDAR.NOTIFY_INVITEES_POPUP._SCHEDULE_BODY_',
                            'CALENDAR.NOTIFY_INVITEES_POPUP._REVIEW_EMAIL_',
                            'CALENDAR.NOTIFY_INVITEES_POPUP._SCHEDULE_CTA_',
                            'CALENDAR.NOTIFY_INVITEES_POPUP._TITLE_', false, true, true).then(function() {
                            defer.resolve(true);
                        }).catch(function() {
                            defer.resolve(false);
                        });
                    } else {
                        defer.resolve(false);
                    }

                    defer.promise.then((notify) => {
                        meetingParams.notify = notify;
                        return this.UsersManager.createCalendarsItem(this.currUser, meetingParams);
                    }).then((resp) => {
                        this.AnalyticsService.trackSuccess(this, this.ANALYTICS_EVENT_SOURCE);
                        this.modalInstance.close(resp.data);
                        this.creatingCalendarItem = false;
                    }).catch((error) => {
                        let errorMsg = 'REPORTS.CALENDAR.MEETING_MODAL.ERRORS._COULD_NOT_CREATE_THIS_MEETING_';
                        this.AnalyticsService.trackError(this, this.AnalyticsService.analytics_events.create_meeting_error, errorMsg, {reason: errorMsg});
                        this.PopupMessageService.showAlert(this.PopupMessageService.severityTypes.error, errorMsg);
                        this.creatingCalendarItem = false;
                    });
                }
                else {
                    this.AnalyticsService.trackError(this, this.AnalyticsService.analytics_events.create_meeting_error, null,
                        {reason: 'missing ' + this._getValidationErrors() });
                }
            }
        }

        updateMeeting() {
            if(!this.updatingCalendarItem) {
                this.meetingFormBinding.meetingForm.$setSubmitted();

                if(this._isValidMeeting()) {
                    this.updatingCalendarItem = true;
                    const meetingParams = this._prepareMeetingParams();

                    const defer = this.$q.defer();

                    if ((this._isMeetingDateChanged() &&
                            (this.CalendarService.hasInvitees(this.existingMeetingParams || this.options) ||
                            this.CalendarService.isConnectedToProject(this.existingMeetingParams || this.options))) ||
                        (meetingParams.workspace_id && !this.existingMeetingParams) || (meetingParams.workspace_id !== this.existingMeetingParams.workspace_id)) {
                        this.showOverlay = true;
                        this.PopupMessageService.showConfirmPromise(
                            this.PopupMessageService.severityTypes.none,
                            'CALENDAR.NOTIFY_INVITEES_POPUP._RESCHEDULE_BODY_',
                            'CALENDAR.NOTIFY_INVITEES_POPUP._REVIEW_EMAIL_',
                            'CALENDAR.NOTIFY_INVITEES_POPUP._RESCHEDULE_CTA_',
                            'CALENDAR.NOTIFY_INVITEES_POPUP._TITLE_', false, true, true).then(function() {
                            defer.resolve(true);
                        }).catch(function() {
                            defer.resolve(false);
                        });
                    } else {
                        defer.resolve(false);
                    }

                    defer.promise.then((notify) => {
                        return this.UsersManager.updateCalendarItem(this.currUser, this.options.calendarItemModel._id, meetingParams, notify);
                    }).then((resp) => {
                        this.AnalyticsService.trackSuccess(this, this.ANALYTICS_EVENT_SOURCE);
                        this.updatingCalendarItem = false;
                        this.modalInstance.close(resp.data);
                    }).catch((error) =>  {
                        this.AnalyticsService.trackError(this, this.AnalyticsService.analytics_events.update_meeting_error, {reason: error});
                        this.PopupMessageService.showAlert(this.PopupMessageService.severityTypes.error, 'REPORTS.CALENDAR.MEETING_MODAL.ERRORS._COULD_NOT_FIND_THIS_MEETING_');
                        this.updatingCalendarItem = false;
                    });
                } else {
                    this.AnalyticsService.trackError(this, this.AnalyticsService.analytics_events.update_meeting_error , null,
                        {reason: 'missing ' + this._getValidationErrors() });
                }
            }
        }



        _closeCreateProjectModal() {
            this.isCreateProject = false;
            this.initButtonLabel();
            this.initTitle();
            this.AnalyticsService.trackClick(this, ['close', this.AnalyticsService.analytics_events.create_project_modal].join(' '),
                {source: this.ANALYTICS_EVENT_SOURCE});
        }

        _formatDatesForServer() {
            this.meetingStartDate = this.moment(this.meetingFormBinding.meetingStartDate).format(this.SERVER_DATE_FORMAT);
            this.meetingEndDate = this.moment(this.meetingFormBinding.meetingEndDate).format(this.SERVER_DATE_FORMAT);
            // time range
            if(this.meetingFormBinding.meetingStartTime && this.meetingFormBinding.meetingEndTime) {
                this.meetingStartTime = this._formatTime(this.meetingFormBinding.meetingStartDate, this.meetingFormBinding.meetingStartTime);
                this.meetingEndTime = this._formatTime(this.meetingFormBinding.meetingEndDate, this.meetingFormBinding.meetingEndTime);
            } else if(!this.meetingFormBinding.isAllDay){
                // if missing start or end time - make it an all day meeting
                this.meetingFormBinding.isAllDay = true;
            }
        }

        _prepareMeetingParams() {
            const workspace = this.meetingFormBinding.selectedWorkspace;
            this._formatDatesForServer();

            return {
                title: this.meetingFormBinding.meetingTitle,
                // timezone: this.meetingFormBinding.timezone,
                date_start: this.meetingStartDate,
                date_time_start: this.meetingStartTime,
                date_time_end: this.meetingEndTime,
                date_end: this.meetingEndDate,
                // mark_as_busy: this.meetingFormBinding.shouldMarkAsBusy,
                all_day: this.meetingFormBinding.isAllDay,
                type: this.meetingFormBinding.meetingType.key,
                location: this.meetingFormBinding.meetingLocation,
                workspace_id: workspace && (workspace.properties.event_name !== "No project") ? workspace._id : null,
                event_id: (workspace && workspace.properties.event_id ? workspace.properties.event_id : null),
                description: this.meetingFormBinding.meetingDescription,
                session_config_id: this.options ? this.options.session_config_id : null,
                video_conference_type: this.meetingFormBinding.videoConferenceType ? this.meetingFormBinding.videoConferenceType.key : null,
                video_meeting_link: this.meetingFormBinding.videoMeetingLink,
                phone_call_number: this.meetingFormBinding.phoneCallNumber
            };
        }

        _isValidMeeting() {
            const is_valid_date = this._validateRequiredField('date', this.meetingFormBinding.meetingStartDate);
            const is_valid_title = this._validateRequiredField('title', this.meetingFormBinding.meetingTitle);
            const is_valid_type = this._validateRequiredField('type', this.meetingFormBinding.meetingType);
            const is_valid_video_conference_type = this._validateVideoConference();
            let is_valid_project = false;

            const errors = Object.keys(this.errors).filter((errorType) => {
                return this.errors[errorType];
            });

            if (this.existingMeetingParams) {
                if(this.existingMeetingParams.event_name === null) {
                    return is_valid_date && is_valid_title && is_valid_type;
                }
            }

            if(!errors.length || (errors.length === 1 && this.errors['project'])) {
                is_valid_project = this._validateProject();
            }

            return is_valid_project && is_valid_video_conference_type && is_valid_date && is_valid_title && is_valid_type;
        }

        _validateVideoConference() {
            this.errors['videoConferenceType'] =
                this.meetingFormBinding.meetingType.key === 'video_call' &&
                (!this.meetingFormBinding.videoConferenceType ||
                    (this.meetingFormBinding.videoConferenceType.key === 'google' &&
                !this.googleCalendarProvider));

            return !this.errors['videoConferenceType'];
        }

        _validateProject() {
            this.errors['project'] = !this.meetingFormBinding.selectedWorkspace;
            if(!this.meetingFormBinding.selectedWorkspace) {
                if(this.isMobile) {
                    this._openMwebConnectProjectModal();
                }
                else {
                    this._openConnectProjectModal();
                }
            }
            return !!this.meetingFormBinding.selectedWorkspace;
        }

        _validateRequiredField(fieldName, fieldValue) {
            this.errors[fieldName] = !fieldValue;
            return !!fieldValue;
        }

        _isValidProjectDate() {
            let startDate = this.project.startDate;
            let endDate = this.project.endDate;
            let startTime = this.project.startTime;
            let endTime = this.project.endTime;
            if(startTime && endTime) {
                startDate = this._formatTime(startDate, startTime);
                endDate = this._formatTime(endDate, endTime);
                return this.moment(startDate).isBefore(endDate);
            }
            else if(startDate && endDate) {
                return this.moment(startDate).isSameOrBefore(endDate);
            }
            return true;
        }

        _getValidationErrors() {
           const errorFields =   _.reduce(this.errors, (result, hasError, fieldName) => {
                (result[hasError] || (result[hasError] = [])).push(fieldName);
                return result;
            }, {})[true];
           return errorFields && errorFields.length > 0 ? errorFields.join(',') : null;
        }

        _openConnectProjectModal() {
            this.showOverlay = true;
            const options = {
                hasActiveProjects: this.meetingFormBinding.hasActiveProjects
            };
            this.ModalService.openConnectProjectModal(options).then((resp) => {
                const {selectedWorkspace, shouldCreateNewProject} = resp;

                if(selectedWorkspace) {
                    this.AnalyticsService.trackSuccess(this, this.AnalyticsService.analytics_events.connect_project_to_meeting,
                        {type: selectedWorkspace.properties.event_name === 'No project' ? 'No project' : 'existing project'});
                    this.meetingFormBinding.setConnectedProject(selectedWorkspace);
                    this.showOverlay = false;

                    if(selectedWorkspace.properties.event_name) {
                        this.submitForm();
                    }
                }
                else if(shouldCreateNewProject) {
                    this.showCreateProject();
                    this.showOverlay = false;
                }
            }).catch((error) => {
                this.AnalyticsService.trackError(this, this.AnalyticsService.analytics_events.connect_project_to_meeting, error);
                this.showOverlay = false;
            });
        }

        _openMwebConnectProjectModal() {
            const options = {
                hasActiveProjects: this.meetingFormBinding.hasActiveProjects
            };
            this.ModalService.openMwebConnectProjectModal(options).then((resp) => {
                if(resp.selectedWorkspace) {
                    this.AnalyticsService.trackSuccess(this, this.AnalyticsService.analytics_events.connect_project_to_meeting,
                        {type: resp.selectedWorkspace.properties.event_name === 'No project' ? 'No project' : 'existing project'});
                    this.meetingFormBinding.setConnectedProject(resp.selectedWorkspace);
                }
                else if(resp.shouldCreateNewProject) {
                    this.showCreateProject();
                }
            }).catch((error) => {
                this.AnalyticsService.trackError(this, this.AnalyticsService.analytics_events.connect_project_to_meeting, error);
            });
        }

        _getProjectAnalyticsProps(project) {
            return this._.pick(project.dataOnly(),
                'event_name', 'event_type', 'event_timezone', 'event_date', 'event_end_date',
                'event_time_start', 'event_time_end', 'lead_source');
        }

        //TODO: deprecate
        _onboardingCreateEventToolTipStep() {
            this.onboardingActive = this.OnboardingService.isOnboardingActive();

            if (this.onboardingActive) {
                this.OnboardingService.setStepComplete(this.OnboardingService.OnboardingSteps.createEventTooltip);
            }
        }

        //TODO: deprecate
        _onboardingCreateEventStep(workspaceId) {
            if (this.onboardingActive) {
                this.OnboardingService.setOnboardingWorkspace(workspaceId);
                this.OnboardingService.setOnboardingEvent(this.project._id);
                this.OnboardingService.setStepComplete(this.OnboardingService.OnboardingSteps.createEvent);
            }
        }

        _initProTip() {
            if (this.UiPersistenceService.getUiPersistence(this.UiPersistenceService.keys.showLeadSourceProTip,
                {show: true}).show && this.currUser.isVendor()) {
                this.showLeadSourceProTip = true;
            }
        }

        _formatTime(date, time) {
            time = this.moment(time, this.TIME_FORMAT);
            return this.moment(date).set({
                'hour': time.get('hour'),
                'minute': time.get('minute'),
                'second': time.get('second')
            }).toString();
        }

        _isMeetingDateChanged() {
            return this.meetingFormBinding.meetingForm.meetingStartDate.$dirty ||
                (!!this.meetingFormBinding.meetingForm.meetingStartTime && this.meetingFormBinding.meetingForm.meetingStartTime.$dirty) ||
                this.meetingFormBinding.meetingForm.meetingEndDate.$dirty ||
                (!!this.meetingFormBinding.meetingForm.meetingEndTime && this.meetingFormBinding.meetingForm.meetingEndTime.$dirty) ||
                this.meetingFormBinding.meetingForm.isAllDay.$dirty;
        }
    };
}());
